export default __webpack_public_path__ + "static/media/password.c63d0485.svg";